import React from "react";
import CardsContainer from "../../components/reusable/containers/CardsContainer";
import theme from "../../styles/theme";

/* =============================================================================
   PAGE TARIFICATION – VERSION PREMIUM / RÉÉCRITE
   ============================================================================= */
const PricingPage = () => {
  return (
    <div style={{ padding: 10, backgroundColor: "#fcfdff" }}>

      {/* ===============================
          HERO SECTION
      =============================== */}
      <section
        style={{
          textAlign: "center",
          paddingTop: 20,
          paddingBottom: 10,
        }}
      >
        <img
          src="/assets/logos/corelia.png"
          alt="Quantum Corelia"
          style={{ width: 70, opacity: 0.92 }}
        />

        <h1
          style={{
            fontSize: theme.fontSizes.xxl,
            color: theme.colors.text.corelia,
            marginTop: 10,
            marginBottom: 6,
          }}
        >
          Tarification Quantum Corelia
        </h1>

        <div
          style={{
            fontSize: theme.fontSizes.lg,
            marginTop: 4,
            color: theme.colors.text.body,
            lineHeight: 1.6,
          }}
        >
          Des offres lisibles, évolutives et adaptées aux pratiques du terrain.
          <br />
          Tarification différenciée pour l’Europe et pour l’Afrique & Maroc.
        </div>
      </section>

      <hr
        style={{
          margin: "22px auto 18px",
          width: "65%",
          borderColor: `${theme.colors.text.caneva}33`,
        }}
      />

      <div
        style={{
          textAlign: "center",
          marginBottom: 24,
          color: theme.colors.text.body,
          fontSize: theme.fontSizes.md,
        }}
      >
        Tous nos packs incluent un <strong>nombre de projets illimité</strong>.
      </div>

      {/* =========================================================================
          SECTION EUROPE
      ========================================================================= */}
      <SectionPricing
        title="Tarifs Europe"
        description="Pour la Belgique, France, Suisse, Luxembourg et l’Union européenne."
      >
        <PricingGrid>
          <PricingCard
            title="Starter"
            price="29 € / mois"
            color={theme.colors.text.caneva}
            items={[
              "1 Admin",
              "1 Collaborateur",
              "2 Viewers",
              "Pour consultants & micro-structures",
            ]}
          />

          <PricingCard
            title="Team"
            price="79 € / mois"
            color={theme.colors.text.corelia}
            badge="Recommandé"
            items={[
              "1 Admin",
              "3 Collaborateurs",
              "5 Viewers",
              "Pour équipes 3–10 personnes",
            ]}
          />

          <PricingCard
            title="Business"
            price="149 € / mois"
            color={theme.colors.text.green}
            badge="Best Value"
            items={[
              "2 Admins",
              "8 Collaborateurs",
              "15 Viewers",
              "Pour BE & directions de projet",
            ]}
          />
        </PricingGrid>

        {/* Pack Projet */}
        <LargeCard
          title="Project License – 99 € / projet / 60 jours"
          color={theme.colors.text.caneva}
          items={[
            "1 Admin Projet",
            "3 Collaborateurs",
            "Viewers illimités",
            "Idéal appels d’offres & missions ponctuelles",
          ]}
        />

        {/* Pack Enterprise */}
        <LargeCard
          title="Enterprise – Sur devis"
          color={theme.colors.text.green}
          items={[
            "Admins illimités",
            "Collaborateurs illimités",
            "Viewers illimités",
            "Support prioritaire",
          ]}
        />
      </SectionPricing>

      {/* ===============================
          COMPARATEUR DE PLANS – EUROPE
      =============================== */}
      <PlanComparator region="Europe" />

      <hr
        style={{
          margin: "36px auto 26px",
          width: "65%",
          borderColor: `${theme.colors.text.caneva}33`,
        }}
      />

      {/* =========================================================================
          SECTION AFRIQUE / MAROC
      ========================================================================= */}
      <SectionPricing
        title="Tarifs Afrique & Maroc"
        description="Adaptés aux réalités des bureaux d’études, entreprises et maîtrises d’ouvrage."
      >
        <PricingGrid>
          <PricingCard
            title="Starter"
            price="19 € / mois"
            color={theme.colors.text.caneva}
            items={["1 Admin", "1 Collaborateur", "2 Viewers"]}
          />

          <PricingCard
            title="Team"
            price="49 € / mois"
            color={theme.colors.text.corelia}
            badge="Recommandé"
            items={["1 Admin", "3 Collaborateurs", "5 Viewers"]}
          />

          <PricingCard
            title="Business"
            price="129 € / mois"
            color={theme.colors.text.green}
            badge="Best Value"
            items={["2 Admins", "8 Collaborateurs", "15 Viewers"]}
          />
        </PricingGrid>

        <LargeCard
          title="Project License – 69 € / projet / 60 jours"
          color={theme.colors.text.caneva}
          items={["1 Admin Projet", "3 Collaborateurs", "Viewers illimités"]}
        />

        <LargeCard
          title="Enterprise – Sur devis"
          color={theme.colors.text.green}
          items={[
            "Admins illimités",
            "Collaborateurs illimités",
            "Viewers illimités",
          ]}
        />
      </SectionPricing>

      {/* ===============================
          COMPARATEUR DE PLANS – AFRIQUE
      =============================== */}
      <PlanComparator region="Afrique & Maroc" />

      {/* ===============================
          UTILISATEURS ADDITIONNELS
      =============================== */}
      <div
        style={{
          textAlign: "center",
          marginTop: 10,
          marginBottom: 20,
          fontSize: theme.fontSizes.sm,
          color: theme.colors.text.body,
          opacity: 0.9,
        }}
      >
        Collaborateur : 15 € / mois — Viewer : 3 € / mois
      </div>
    </div>
  );
};

/* =============================================================================
   COMPOSANTS RÉUTILISABLES
============================================================================= */
const SectionPricing = ({ title, description, children }) => (
  <section style={{ marginBottom: 50 }}>
    <h2
      style={{
        textAlign: "center",
        fontSize: theme.fontSizes.xl,
        color: "#B8621B",
        marginBottom: 6,
      }}
    >
      {title}
    </h2>

    <div
      style={{
        width: 80,
        height: 3,
        backgroundColor: "#B8621B",
        margin: "6px auto 14px",
        borderRadius: 2,
      }}
    />

    <p
      style={{
        textAlign: "center",
        color: theme.colors.text.body,
        marginBottom: 18,
      }}
    >
      {description}
    </p>

    {children}
  </section>
);

const PricingGrid = ({ children }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(3, 320px)",
      justifyContent: "center",
      gap: "26px",
      marginBottom: 30,
    }}
  >
    {children}
  </div>
);

const PricingCard = ({ title, price, color, items, badge }) => (
  <div
    style={{
      border: "1px solid #e2e8f0",
      padding: 20,
      borderRadius: 4,
      backgroundColor: "white",
      width: 320,
      minHeight: 300,
      boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    }}
  >
    {badge && (
      <div
        style={{
          position: "absolute",
          top: -10,
          right: -10,
          background: color,
          color: "white",
          padding: "4px 10px",
          borderRadius: 4,
          fontSize: 12,
        }}
      >
        {badge}
      </div>
    )}

    <h3 style={{ color, fontSize: theme.fontSizes.lg, marginBottom: 8 }}>
      {title}
    </h3>

    <div
      style={{
        fontSize: theme.fontSizes.xl,
        fontWeight: theme.fontWeights.medium,
        marginBottom: 14,
      }}
    >
      {price}
    </div>

    <ul style={{ paddingLeft: 20, flexGrow: 1, lineHeight: 1.6 }}>
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>

    <button
      style={{
        width: "100%",
        padding: "10px 0",
        borderRadius: 4,
        border: "none",
        backgroundColor: color,
        color: "white",
        fontSize: theme.fontSizes.sm,
        cursor: "pointer",
      }}
    >
      Nous contacter
    </button>
  </div>
);

const LargeCard = ({ title, color, items }) => (
  <CardsContainer justify="center" align="center" gap={0}>
    <div
      style={{
        width: "1000px",
        border: "1px solid #e2e8f0",
        borderRadius: 4,
        backgroundColor: "white",
        padding: "28px",
        marginBottom: 20,
        boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
      }}
    >
      <h3
        style={{
          color,
          fontSize: theme.fontSizes.lg,
          marginBottom: 10,
        }}
      >
        {title}
      </h3>

      <ul style={{ paddingLeft: 20, lineHeight: 1.6 }}>
        {items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </div>
  </CardsContainer>
);

/* =============================================================================
   COMPARATEUR DE PLANS
============================================================================= */
const PlanComparator = ({ region }) => (
  <div
    style={{
      width: "1000px",
      margin: "0 auto 40px",
      border: "1px solid #e2e8f0",
      borderRadius: 6,
      backgroundColor: "#ffffff",
      boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
      overflow: "hidden",
    }}
  >
    <div
      style={{
        backgroundColor: "#f9fafb",
        padding: "14px 20px",
        borderBottom: "1px solid #e2e8f0",
        fontWeight: theme.fontWeights.medium,
        fontSize: theme.fontSizes.md,
        color: theme.colors.text.caneva,
      }}
    >
      Comparateur de plans – {region}
    </div>

    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontSize: theme.fontSizes.sm,
      }}
    >
      <thead>
        <tr>
          <th style={th}>Fonctionnalités</th>
          <th style={th}>Starter</th>
          <th style={th}>Team</th>
          <th style={th}>Business</th>
        </tr>
      </thead>

      <tbody>
        {[
          ["Admins", "1", "1", "2"],
          ["Collaborateurs", "1", "3", "8"],
          ["Viewers", "2", "5", "15"],
          ["Projets illimités", "✔", "✔", "✔"],
          ["Modules Canevas complets", "✔", "✔", "✔"],
          ["Gestion documentaire 19650", "✔", "✔", "✔"],
          ["Viewer BIM (Forge / IFC)", "—", "✔", "✔"],
          ["Workflows avancés", "—", "✔", "✔"],
          ["Support prioritaire", "—", "—", "✔"],
        ].map((row, i) => (
          <tr key={i}>
            {row.map((cell, j) => (
              <td key={j} style={td}>
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const th = {
  background: "#f9fafb",
  padding: "10px 14px",
  borderBottom: "1px solid #e2e8f0",
  textAlign: "center",
  fontWeight: 600,
};

const td = {
  padding: "10px 14px",
  borderBottom: "1px solid #e2e8f0",
  textAlign: "center",
};

export default PricingPage;


